// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2PFMw","addWidgetButton":"Header_addWidgetButton__2H7WE","dashboardTabs":"Header_dashboardTabs__mCW43","active":"Header_active__vJ6b6"};